import { useState } from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import general from 'configs/general';

import { MapWrapper, MapPinMarkerWrapper, MapPinMarker } from './GoogleMaps.style';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const GoogleMaps = ({ selectedLocation, handleLocationChange }) => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [removePopup, setRemovePopup] = useState(false);
  const [mapInstance, setMapInstance] = useState(null);
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  const apiLoadCallback = map => {
    setMapInstance(map);
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleMapDragged = () => {
    setRemovePopup(true);
  };

  const handleMapDragEnd = () => {
    const location = {
      lat: mapInstance.center.lat(),
      lng: mapInstance.center.lng(),
    };

    handleLocationChange(location);
    setRemovePopup(false);
  };

  const handleZoomEnd = () => {
    const location = {
      lat: mapInstance.center.lat(),
      lng: mapInstance.center.lng(),
    };

    handleLocationChange(location);
    setRemovePopup(false);
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <MapWrapper>
      <MapPinMarkerWrapper>
        <MapPinMarker />
      </MapPinMarkerWrapper>
      <GoogleMapReact
        bootstrapURLKeys={{
          key: general.socialNetworksAppKeys.googleApi,
          libraries: ['places'],
        }}
        defaultCenter={{ lat: selectedLocation.lat, lng: selectedLocation.lng }}
        defaultZoom={14}
        options={{
          zoomControl: false,
          fullscreenControl: false,
        }}
        removePopup={removePopup}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={({ map }) => apiLoadCallback(map)}
        onDrag={handleMapDragged}
        onDragEnd={handleMapDragEnd}
        onZoomAnimationEnd={handleZoomEnd}
      />
    </MapWrapper>
  );
};
// ###############################################################
// <----------------------- End Return UI ----------------------->
// ###############################################################

GoogleMaps.propTypes = {
  selectedLocation: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }).isRequired,
  handleLocationChange: PropTypes.func.isRequired,
};

GoogleMaps.defaultProps = {};

export default GoogleMaps;
